import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { darken, lighten, alpha } from "@mui/material";
import Typography from "@mui/material/Typography";

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import { ViewBs4EventList } from './Bs4ReportCalendarViewBs4Event'
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';

import { useDroppable } from '@dnd-kit/core';


import {    
  addDays, startOfDay, endOfDay,
  startOfWeek, endOfWeek,  
  startOfMonth, endOfMonth,
  startOfYear, endOfYear,
  compareAsc,
  eachDayOfInterval, eachWeekOfInterval, eachMonthOfInterval,
  format,
  addMilliseconds,
  getMonth,
  differenceInCalendarDays,
} from "date-fns";

import Bs4ReportCalendarView from './Bs4ReportCalendarView'
import {   
  // TYPE_NAVIGATION,
  // TYPE_CALENDAR,
  // TYPE_AGENDE,
  // TYPE_SCHEDULER,
  // TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  // VIEW_TYPE_MODIFIER_LAYER0,
  // VIEW_TYPE_MODIFIER_LAYER1,
  // VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  // footerButtons,
  // isSelected,
} from './Bs4ReportCalendarConst';

const DROPPABLE = 'droppable';

export default class Bs4ReportCalendarViewYear extends Bs4ReportCalendarView {

  scrollMargin = 5;
  
  deyPadding = 2;

  y_d = 'y-D';

  ViewDayName = React.memo((props) => {
    const report = this;

    const minWidth = 25;
    const minHeight = 25;

    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gridRow={props.gridRow}
        gridColumn={props.gridColumn}
        sx={{
          width: minWidth,
          height: minHeight,
          padding: report.deyPadding,
        }}
      >
        <Typography variant='subtitle2' sx={{userSelect: 'none'}}>{format(props.day.date, 'iiiii')}</Typography>
      </Box> 
    )
  });

  ViewDay = React.memo((props) => {
    const report = this;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const backgroundColor = React.useMemo(() => {
      // console.log('...Bs4ReportCalendarViewYear...backgroundColor...', );
      if (! props.day?.bs4Events?.length > 0) return 'transparent';
      const a = Math.min(0.7, 0.07 * props.day.bs4Events.length) / 2.0;
      return alpha(theme.palette.primary.main, a);
    }, [props.day?.bs4Events?.length, theme, props.calendarChangeTime]);
    const ref = React.useRef(null);
    let elId = 0;

    const elArray = React.useMemo(() => {
      const elArray = props.day.bs4Events.map(bs4Event => {
        const bs4EventStart = startOfDay(props.day.date);
        const bs4EventEnd = endOfDay(props.day.date);
        return {
          id: elId++,
          bs4Event: bs4Event,
          start: bs4EventStart,
          end: bs4EventEnd,
          startTime: bs4EventStart.getTime(),
          endTime: bs4EventEnd.getTime(),
        }
      })
      return elArray;
    }, [props.day])

    const square = 25;

    const handleNavigateTo = (event) => {
      if (props.day?.bs4Events?.length > 0) {
        setAnchorEl(ref.current);
      } else {
        props.onChangeView(props.day.date, VIEW_TYPE_DAY);
      }
    }

    const handleNavigateToNaw = (event) => {
      props.onChangeView(props.day.date, VIEW_TYPE_DAY);
    }

    const handleClose = (event) => {
      setAnchorEl(null);
    }

    const handleRowClick = (bs4Event) => {
      props.onRowClick(bs4Event);
      handleClose();
    }

    const now = React.useMemo(() => {
      const now = startOfDay(new Date());
      const day = startOfDay(props.day.date);
      return compareAsc(now, day) === 0;
    }, [props.day.date])

    // console.log('...Bs4ReportCalendarViewYear...ViewDay...', props);

    return (      
      <Box 
        ref={ref}
        gridRow={props.gridRow}
        gridColumn={props.gridColumn}
        backgroundColor={backgroundColor}
      >
        <IconButton
          onClick={handleNavigateTo}
          size='small'
          sx={{
            width: square,
            height: square,
            padding: report.deyPadding,
            border: now ? '3px dashed #ff000022' : null,
          }}
        >
          <Typography variant='subtitle2' sx={{color: props.day.inMonth ? '#000000ff' : '#00000055'}}>{format(props.day.date, 'd')}</Typography>
        </IconButton> 
        <ViewBs4EventList 
          title={format(props.day.date, 'iiii, d')}
          elArray={elArray} 
          anchorEl={anchorEl} 
          onClose={handleClose} 
          bs4kartotekaid={report.bs4KartotekaId} 
          onChangeView={handleNavigateToNaw}
          onRowClick={handleRowClick}
          bs4Calendar={props.bs4Calendar}
        />
      </Box>
    )
  });

  ViewMonthDroppable = (props) => {
    const setBs4ActiveMove = React.useCallback((active, over, propsEnd) => {
      const el = active.props.el;
      if (!el.bs4Event.chtime) return;
      
      if (!over) {
        if (propsEnd) {
          if (el.bs4Event.move.cursor) {
            propsEnd.bs4EventResize(el.bs4Event);
          } else {
            propsEnd.bs4EventDrop(el.bs4Event);
          }
        }        
        return;
      }    
      
      const rect = over.rect;
      const pointerCoordinates = over.data.current.droppableRef.pointerCoordinates;
      
      const weekNumber = Math.floor(6 * (pointerCoordinates.y - rect.top) / rect.height);
      const dayNumber = Math.floor(7 * (pointerCoordinates.x - rect.left) / rect.width);
      if (weekNumber < 0 || weekNumber > 6 || dayNumber < 0 || dayNumber > 6) return;

      let moveDate = null
      try {
        moveDate = props.month.weeks[weekNumber].days[dayNumber].date;
      } catch(error) {
        // console.log('...setBs4ActiveMove.MOUTH...', format(props.month?.date, 'LLLL'), error);  
        return;
      }

      const differenceInCalendarDaysMove = differenceInCalendarDays(moveDate, el.bs4Event.start);
      const start = addDays(el.bs4Event.start, differenceInCalendarDaysMove);
      if (compareAsc(start, el.bs4Event.start) === 0) return;
      el.bs4Event.start = start;
      el.bs4Event.end = addMilliseconds(el.bs4Event.start, el.bs4Event.duration);    
      if (navigator.vibrate) navigator.vibrate(1);
    }, [props.month]);

    const [droppableRef, setDroppableRef] = React.useState({})

    const  {isOver, active, setNodeRef, node} = useDroppable({
      id: DROPPABLE+'_'+VIEW_TYPE_MONTH+'_'+Bs4Utils.toDate(props.month.date),
      data: {
        setBs4ActiveMove: setBs4ActiveMove,
        droppableRef: droppableRef,
      }
    });

    return (      
      <Box
        ref={setNodeRef}
        gridRow={'2/8'}
        gridColumn={'2/9'}            
        // border={'solid'}
      />
    )
  }  

  ViewMonth = React.memo((props) => {
    const report = this;            

    const handleNavigateToMonth = () => {
      if (props.onChangeView) props.onChangeView(props.month.date, VIEW_TYPE_MONTH);
    }

    const handleNavigateToWeek = (date) => {    
      if (props.onChangeView) props.onChangeView(date, VIEW_TYPE_WEEK);
    }

    const square = 25;

    // console.log('...ViewMonth...', format(props.month?.date, 'LLLL'), props.activeMonth, props.activeMonth.weeks, props.activeMonth.weeks.map);

    return (
      <Stack 
        direction="column" 
        position='relative'
        spacing={0} 
        sx={{
          flex: '1 1 25%' , 
          justifyContent: "flex-start", 
          alignItems: "flex-start", 
          padding: 2,
        }}
      >        
        <Button 
          variant='text'
          onClick={event => handleNavigateToMonth()} 
        > 
          <Typography>{format(props.month?.date, 'LLLL')}</Typography> 
        </Button>
        <Box
          display='grid'
          gridTemplateColumns='repeat(8, 1fr)'
          gridTemplateRows='repeat(7, 1fr)'
        >
          <Typography>{''}</Typography>
          {props.month.weeks[0].days.map((day, index) => {
            return (
              <report.ViewDayName 
                key={day.date} 
                day={day} 
                gridRow={'1'}
                gridColumn={`${index + 2}`}
              />
            )
          })}
          {props.month.weeks.map((week, indexWeek) => {             
            return (
              <React.Fragment key={week.start}>
                <IconButton                
                  onClick={() => handleNavigateToWeek(week.start)}
                  size='small'
                  sx={{
                    gridRow: `${indexWeek + 2}`,
                    gridColumn: '1',
                    width: square,
                    height: square,
                    padding: report.deyPadding,
                  }}
                >
                  <Typography variant='subtitle2' sx={{opacity: 0.5, fontSize: '11px'}}>{format(week.days[0].date, 'w')}</Typography>
                </IconButton>
                {week.days.map((day, indexDay) => {
                  return (
                    <report.ViewDay
                      key={day.date}                                                                
                      day={day}
                      date={props.month.date}
                      onChangeView={props.onChangeView}
                      onRowClick={props.onRowClick}
                      calendarChangeTime={props.calendarChangeTime}
                      gridRow={`${indexWeek + 2}`}
                      gridColumn={`${indexDay + 2}`}    
                      bs4Calendar={props.bs4Calendar}                
                    />
                  )
                })}
              </React.Fragment>
            )
          })}
          {props.activeMonth.weeks.map((week, indexWeek) => { 
            return (                
              week.days.map((day, indexDay) => {
                if (!day) return null;
                return (
                  <Box 
                    key={'active'+day.date}                     
                    gridRow={`${indexWeek + 2}`}
                    gridColumn={`${indexDay + 2}`}
                    backgroundColor='#ff000099'
                  />
                )
              })
            )
          })}
          <report.ViewMonthDroppable
            month={props.month}
          />
        </Box>        
      </Stack>
    );
  });

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;

    const refBox = React.useRef(null);
    const year = React.useMemo(() => {      
      const days = {};
      
      // props.bs4Calendar.events.forEach(bs4Event => {
      props.bs4Calendar.getVisibleEvents().forEach(bs4Event => {
        if (compareAsc(bs4Event.end, props.bs4Calendar.start) < 0 || compareAsc(bs4Event.start, props.bs4Calendar.end) > 0) return
        eachDayOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
          const key = format(date, this.y_d, {useAdditionalDayOfYearTokens: true}); 
          let bs4Events = days[key];
          if (!bs4Events) {
            bs4Events = []
            days[key] = bs4Events;
          }
          bs4Events.push(bs4Event);
        })
      });

      // console.log('...Bs4ReportCalendarViewYear...days...', days);
      
      const year = eachMonthOfInterval({start: startOfYear(props.bs4Calendar.date), end: endOfYear(props.bs4Calendar.date)}).map(monthDate => {
        const monthStart = startOfWeek(startOfMonth(monthDate));
        const monthEnd = addDays(monthStart, 7 * 6 - 1);
        return {
          date: monthDate,
          start: monthStart,
          end: monthEnd,
          weeks: eachWeekOfInterval({start: monthStart, end: monthEnd}).map(weekDate => {
            const weekStart = startOfWeek(weekDate);
            const weekEnd = endOfWeek(weekDate);
            return {
              start: weekStart,
              end: weekEnd,
              days: eachDayOfInterval({start: weekStart, end: weekEnd}).map(dayDate => {
                return {
                  date: dayDate,
                  bs4Events: days[format(dayDate, this.y_d, {useAdditionalDayOfYearTokens: true})] || [], 
                  inMonth: getMonth(monthDate) === getMonth(dayDate),
                }
              }),
            }
          }),
        }
      });
      
      return year;
    }, [props.bs4Calendar.date, props.bs4Calendar.start, props.bs4Calendar.end, props.calendarChangeTime])

    const activeYear = React.useMemo(() => {            
      const days = {};
      const bs4Event = props.active?.props?.el?.bs4Event;
      if (!bs4Event || compareAsc(bs4Event.end, props.bs4Calendar.start) < 0 || compareAsc(bs4Event.start, props.bs4Calendar.end) > 0) ;
      else eachDayOfInterval({start: bs4Event.start, end: bs4Event.end}).forEach(date => {
        const key = format(date, this.y_d, {useAdditionalDayOfYearTokens: true}); 
        let bs4Events = days[key];
        if (!bs4Events) {
          bs4Events = []
          days[key] = bs4Events;
        }
        bs4Events.push(bs4Event);
      })

      const yearStart = startOfYear(props.bs4Calendar.date);
      const yearEnd = endOfYear(props.bs4Calendar.date);
      const year = eachMonthOfInterval({start: yearStart, end: yearEnd}).map(monthDate => {
        const monthStart = startOfWeek(startOfMonth(monthDate));
        const monthEnd = addDays(monthStart, 7 * 6 - 1);
        if (!bs4Event || compareAsc(bs4Event.end, monthStart) < 0 || compareAsc(bs4Event.start, monthEnd) > 0) return {
          date: monthDate,
          start: monthStart,
          end: monthEnd,
          weeks: [],
        };
        return {
          date: monthDate,
          start: monthStart,
          end: monthEnd,
          weeks: eachWeekOfInterval({start: monthStart, end: monthEnd}).map(weekDate => {
            const weekStart = startOfWeek(weekDate);
            const weekEnd = endOfWeek(weekDate);
            if (!bs4Event || compareAsc(bs4Event.end, weekStart) < 0 || compareAsc(bs4Event.start, weekEnd) > 0) return {
              start: weekStart,
              end: weekEnd,
              days: [],
            };
            return {
              start: weekStart,
              end: weekEnd,
              days: eachDayOfInterval({start: weekStart, end: weekEnd}).map(dayDate => {
                const bs4Events = days[format(dayDate, this.y_d, {useAdditionalDayOfYearTokens: true})] || [];
                if (!bs4Event || bs4Events.length === 0) return null;
                return {
                  date: dayDate,
                  bs4Events: days[format(dayDate, this.y_d, {useAdditionalDayOfYearTokens: true})] || [], 
                  inMonth: getMonth(monthDate) === getMonth(dayDate),
                }
              }),
            }
          }),
        }
      });
      
      return year;
    }, [props.bs4Calendar.date, props.activeChangeTime, props.active])

    React.useEffect(() => {      
      console.log()
      if (props.setScrollTarget) props.setScrollTarget(refBox.current, 'grid');
    }, [refBox.current]);
  
    // console.log('...Bs4ReportCalendarViewYear...View', year);

    //display='flex' zapewnia skalowanie - zmienna ilość kolumn zależna od szerokości.    

    return (
      <Stack 
        direction="column" 
        spacing={0} 
        sx={{
          height: '100%',
          justifyContent: "flex-start", 
          alignItems: "center",
          overflow: 'hidden',
        }}
      >   
        <Typography>{format(props.bs4Calendar.date, 'yyyy')}</Typography>
        <Box 
          ref={refBox}
          id='Box_Bs4ReportCalendarYear'
          display='flex'
          flexDirection={'row'}
          flexWrap={'wrap'}        
          justifyContent='space-between'
          // alignItems="space-around"
          // justifyContent='space-around'
          flex={1} 
          overflow='auto'
        >
          {year.map((month, index) => {        
            return (
              <report.ViewMonth
                key={month.date} 
                date={props.bs4Calendar.date} 
                month={month}              
                onChangeView={props.onChangeView} 
                onRowClick={props.onRowClick}
                calendarChangeTime={props.calendarChangeTime}
                activeMonth={activeYear[index]} 
                active={props.active}
                bs4Calendar={props.bs4Calendar}
              />
            )
          })}        
        </Box>
      </Stack>
    );        
  });
}